

import React from 'react';
import { Button, IconButton } from '@mui/material'; // Import IconButton here
import EmailIcon from '@mui/icons-material/Email';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // Import ArrowBackIcon here
import { useLocation, useNavigate } from 'react-router-dom'; // Import useNavigate here
import Navbar from './Navbar';
import ManagerHeader from './ManagerHeader'; // Import ManagerHeader
import Swal from 'sweetalert2';

// Function to send the message (trigger the API call)
const sendMessage = async (messageId) => {
  const managerId = localStorage.getItem('managerID'); // Get manager ID from local storage

  if (!managerId) {
    Swal.fire({
      title: "Error",
      text: "Manager ID not found. Please login again.",
      icon: "error",
      confirmButtonText: "OK",
    });
    return;
  }

  // Send the GET request to the backend
  try {
    const response = await fetch(
      `https://server-side-influencer.onrender.com/manager/send-email/${messageId}/${managerId}`,
      {
        method: "GET",
      }
    );
    const data = await response.json();

    // Check if the email was sent successfully
    if (data.success) {
      Swal.fire({
        title: "Request Sent",
        text: "Your request has been sent. You will be contacted through email for this post.",
        icon: "success",
        confirmButtonText: "OK",
      });
    } else {
      Swal.fire({
        title: "Error",
        text: "There was an error sending your request. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  } catch (error) {
    console.error("Error sending request:", error);
    Swal.fire({
      title: "Error",
      text: "There was an issue with the server. Please try again later.",
      icon: "error",
      confirmButtonText: "OK",
    });
  }
};

const SendPostRequest = () => {
  const { state } = useLocation();  // Access the passed data via state
  const { brandData } = state || {}; // Destructure the brand data
  const navigate = useNavigate(); // Initialize navigate from useNavigate

  if (!brandData) {
    return <div>Loading...</div>; // Fallback if no brand data is available
  }

  const {
    brandLogo,
    brandbackgroundimage,
    message,
    shopName,
    platform,
    influencerFollowersCount,
    youtubeCount,
    budget,
    whatsappNumber,
    location,
    category,
    language,
    influencerCount,
    _id, // Assuming _id is the messageId you want to pass to the API
  } = brandData;

  return (
    <div className="flex h-screen mb-0">
      <div className="h-screen ml-1 max-sm:ml-0 w-screen">


        <div className="bg-white shadow-md flex items-center p-4">
          {/* Back Button */}
          <IconButton onClick={() => navigate(-1)} color="primary" edge="start">
            <ArrowBackIcon />
          </IconButton>
          <div className="ml-4 flex-grow">
            <h2 className="text-2xl font-bold text-gray-800">Back</h2>
          </div>
        </div>

        <div className="container mx-auto p-4 ml-10">
          <div
            className="relative h-[50vh] rounded-lg mb-8"
            style={{ backgroundImage: `url(${brandbackgroundimage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
          >
            <div
              className="absolute bottom-10 left-1/2 transform -translate-x-1/2 rounded-full w-28 h-28 bg-cover bg-center border-4 border-white"
              style={{ backgroundImage: `url(${brandLogo})` }}
            />
          </div>
          <div className="text-center mb-12">
            <h2 className="text-sm sm:text-base md:text-lg lg:text-4xl font-bold mb-2">{shopName}</h2>
          </div>

          <div className="mb-12  ml-12">
            <div className="space-y-2">
              <p className="text-gray-600 lg:text-lg"><strong>campaign breif:</strong> {message}</p>
              <p className="text-gray-600 lg:text-lg"><strong>Platform:</strong> {platform}</p>
              <p className="text-gray-600 lg:text-lg"><strong>Followers:</strong> {influencerFollowersCount}</p>
              {/* <p className="text-gray-600"><strong>YouTube Count:</strong> {youtubeCount}</p> */}
              <p className="text-gray-600 lg:text-lg"><strong>Budget:</strong> ₹{budget}</p>
              <p className="text-gray-600 lg:text-lg"><strong>Location:</strong> <a href={location} target="_blank" rel="noopener noreferrer">{location}</a></p>
              <p className="text-gray-600 lg:text-lg"><strong>Category:</strong> {category}</p>
              <p className="text-gray-600 lg:text-lg"><strong>Language:</strong> {language}</p>
              <p className="text-gray-600 lg:text-lg"><strong>Required Influencers:</strong> {influencerCount}</p>
            </div>
          </div>

          <div className="text-left ml-4">
            <Button
              variant="contained"
              size="large"
              endIcon={<EmailIcon />}
              sx={{
                background: 'linear-gradient(to bottom right, #7e22ce, #3b82f6)', // Gradient from purple to blue
                '&:hover': {
                  background: 'linear-gradient(to top left, #7e22ce, #3b82f6)', // Hover effect gradient
                },
                color: 'white', // Text color white
                fontWeight: '600', // Optional: make the text bold
                borderRadius: '9999px', // Full rounded corners (same as rounded-full)
                padding: '0.75rem 2rem', // Padding to match button size (px-8 py-3)
              }}
              onClick={() => sendMessage(_id)} // Pass the message ID here
            >
              Send Request
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendPostRequest;
